import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatDetail } from "@/lib/api";
import BrandMark from "@/components/BrandMark";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const isInvite = params.get("invite") === "1";
  const nav = useNavigate();
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) setErr("Missing or invalid reset link");
  }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (newPw.length < 10) return setErr("Password must be at least 10 characters");
    if (newPw !== confirmPw) return setErr("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPw });
      toast.success(isInvite ? "Welcome aboard — sign in with your new password" : "Password reset — sign in with your new password");
      nav("/login");
    } catch (e2) { setErr(formatDetail(e2.response?.data?.detail) || "Reset failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] text-zinc-900 p-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="reset-form">
        <Link to="/" className="inline-block mb-10"><BrandMark variant="lockup" size={64} /></Link>
        <div className="text-xs uppercase tracking-[0.3em] text-zinc-500">{isInvite ? "Welcome to Collation Watch" : "Account Recovery"}</div>
        <h2 className="font-display text-4xl mt-2 mb-3" data-testid="reset-heading">{isInvite ? "Set your password" : "Choose a new password"}</h2>
        {isInvite && <p className="text-sm text-zinc-500 mb-6" data-testid="invite-intro">You've been invited to the console. Pick a password (10+ characters) and you'll be able to sign in right away.</p>}
        {!isInvite && <div className="mb-5"/>}
        <label className="text-xs uppercase tracking-[0.2em] text-zinc-500">New password</label>
        <input type="password" value={newPw} onChange={e=>setNewPw(e.target.value)} required autoFocus
          data-testid="reset-new-password"
          className="w-full bg-transparent border-b border-black/20 py-3 focus:border-black outline-none text-lg mb-6"/>
        <label className="text-xs uppercase tracking-[0.2em] text-zinc-500">Confirm password</label>
        <input type="password" value={confirmPw} onChange={e=>setConfirmPw(e.target.value)} required
          data-testid="reset-confirm-password"
          className="w-full bg-transparent border-b border-black/20 py-3 focus:border-black outline-none text-lg mb-8"/>
        {err && <div className="text-sm text-red-500 mb-4" data-testid="reset-error">{err}</div>}
        <button type="submit" disabled={busy || !token} data-testid="reset-submit-btn"
          className="w-full py-4 bg-black text-white font-semibold uppercase tracking-[0.2em] text-sm hover:bg-zinc-800 disabled:opacity-50">
          {busy ? "Saving..." : isInvite ? "Set password & continue" : "Reset password"}
        </button>
        <div className="mt-6 text-xs text-zinc-500">
          <Link to="/login" className="underline underline-offset-4 hover:text-black">← Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
